export const EMPTY_SCHEMA = Symbol.for('EMPTY_SCHEMA')
